import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { BaseEndpoint } from '../app.constants';
import { LoanProgram, AddLoanProgram, AssignmentStrategy, LoanChannel, Region } from './loanprogram.model';
import { Product } from './product.model';
import { Audit } from '../audits/audit.model';

@Injectable()
export class LoanProgramService {
    @Output() requestAdded = new EventEmitter<any[]>();
    @Output() programAdded = new EventEmitter<any>();
    @Output() programUpdated = new EventEmitter<any>();
    @Output() programDeleted = new EventEmitter<any>();
    private programs: LoanProgram[] = [];
    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl, private adalService: AdalService) {


    }

    getAssignmentStrategies(): Promise<AssignmentStrategy[]> {
        var url = this.baseApiUrl + 'v1/assignmentstrategies';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var strats = resp.json().body as AssignmentStrategy[];
                var assignmentStrategiesU = JSON.parse(JSON.stringify(strats));
                return assignmentStrategiesU;
            })
            .catch(this.handleError);
    }

    getRegionAssignmentStrategies(): Promise<Region[]> {
        var url = this.baseApiUrl + 'v1/regionassignmentstrategies';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var strats = resp.json().body as Region[];
                var assignmentStrategiesR = JSON.parse(JSON.stringify(strats));
                return assignmentStrategiesR;
            })
            .catch(this.handleError);
    }

    getRegionAssignmentStrategiesByGroupName(groupName: string): Promise<Region[]> {
        var url = this.baseApiUrl + 'v1/getregionassignmentstrategiesbygroup/' + groupName;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var strats = resp.json().body as Region[];
                var assignmentStrategiesR = JSON.parse(JSON.stringify(strats));
                return assignmentStrategiesR;
            })
            .catch(this.handleError);
    }


    getUserLoanPrograms(userId: string): Promise<LoanProgram[]> {
        var url = this.baseApiUrl + 'v1/loanprograms/' + userId;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var user = resp.json().body as LoanProgram[];
                return user;
            })
            .catch(this.handleError);
    }

    getLoanPrograms(): Promise<LoanProgram[]> {
        var url = this.baseApiUrl + 'v1/loanprograms';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var loanPrograms = resp.json().body as LoanProgram[];
                return loanPrograms;
            })
            .catch(this.handleError);
    }

    getAllProducts(): Promise<Product[]> {
        var url = this.baseApiUrl + 'v1/products';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var products = resp.json().body as Product[];
                return products;
            })
            .catch(this.handleError);
    }

    getProducts(id: string): Promise<Product[]> {
        var url = this.baseApiUrl + 'v1/products/' + id;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var products = resp.json().body as Product[];
                return products;
            })
            .catch(this.handleError);
    }

    async putProgram(program: LoanProgram): Promise<LoanProgram> {
        const url = this.baseApiUrl + 'v1/loanprograms/' + program.id;
        let headers = await this.adalService.createServiceHeader();
        return this.http
            .put(url, JSON.stringify(program), { headers: headers })
            .toPromise()
            .then(resp => {
                var success = !resp.json().hasErrors as boolean;
                if (success) {
                    var updatedProgram = resp.json().body as LoanProgram;
                    this.programUpdated.emit(updatedProgram);
                }
                return success;
            })
            .catch(this.handleError);
    }

    deleteProgram(programId: string): Promise<boolean> {
        var url = this.baseApiUrl + 'v1/loanProgram/' + programId;
        return this.http
            .delete(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var success = !resp.json().hasErrors as boolean;
                if (success) {
                    this.programDeleted.emit(programId);
                }
                return success;
            })
            .catch(this.handleError);
    }

    addProgram(program: AddLoanProgram): Promise<LoanProgram> {
        var url = this.baseApiUrl + 'v1/loanprograms';
        return this.http
            .post(url, program, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                const newProgram = resp.json().body as LoanProgram;
                this.programAdded.emit(newProgram);
                return newProgram;
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    getLoanChannels(): Promise<LoanChannel[]> {
        var url = this.baseApiUrl + 'v1/loanchannels';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var strats = resp.json().body as LoanChannel[];
                var loanChannels = JSON.parse(JSON.stringify(strats));
                return loanChannels;
            })
            .catch(this.handleError);
    }

    getLoanProgramByName(programName) {
        var url = this.baseApiUrl + 'v1/getloanprogram/' + programName;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var loanPrograms = resp.json().body;
                return loanPrograms;
            })
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/loanprogram.service.ts